type AgentChatFullscreenControls = {
	open: () => void;
	close: () => void;
};

let controls: AgentChatFullscreenControls | null = null;

export function registerAgentChatFullscreenControls(
	nextControls: AgentChatFullscreenControls,
) {
	controls = nextControls;

	return () => {
		if (controls === nextControls) {
			controls = null;
		}
	};
}

export function openAgentChatFullscreen() {
	controls?.open();
}

export function closeAgentChatFullscreen() {
	controls?.close();
}
